import { useUserPermission } from '@/lib/auth';
import { Feature, FeatureKey } from '@/types/feature';

export const useAvailableFeatureChecker = (featureKeyToCheck: FeatureKey) => {
  const query = useUserPermission();
  const checkedFeature = query.data?.availableFeatures?.find(
    (feature: Feature) => feature.key === featureKeyToCheck
  );

  return {
    ...query,
    isAvailable: Boolean(checkedFeature),
    defaultConfiguration: checkedFeature?.defaultConfiguration ?? null,
  };
};
